// extracted by mini-css-extract-plugin
module.exports = {"linkableItem":"style-module_linkableItem__qiGykcsbh-tXpOLRMhpin"};